import { render, staticRenderFns } from "./RelatedMediaItemModal.vue?vue&type=template&id=b245d6dc&"
import script from "./RelatedMediaItemModal.vue?vue&type=script&lang=js&"
export * from "./RelatedMediaItemModal.vue?vue&type=script&lang=js&"
import style0 from "./RelatedMediaItemModal.vue?vue&type=style&index=0&id=b245d6dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports